module.exports = __webpack_public_path__ + "img/9788990364975.ab0ddf26.jpg";